import { render } from "./SwitchInput.vue?vue&type=template&id=e2c0eed8&ts=true"
import script from "./SwitchInput.vue?vue&type=script&lang=ts"
export * from "./SwitchInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__